export default "<a href=\"javascript:void(0)\" (click)=\"openImage()\">Alterar foto do perfil</a>"